const dataSourceKind = {
    raw: 'Raw',
    ref: 'Ref',
    rawAndRef: 'RawAndRef',
    globalRef: 'GlobalRef',
    accuracy: 'Accuracy',
    globalModule:'GlobalModule'
};

export default dataSourceKind;
